
define('app/board/views/lastPickView',[
	'jquery',
	'underscore',
	'backbone',
	'app/board/collections/pickSummaryCollection',
	'app/board/models/draftStatusModel',
	'app/board/models/positionColorsModel',
	'known/models/leagueInstanceModel',
	'known/models/userModel'
], function($, _, Backbone, PickSummaryCollection, DraftStatusModel, PositionColorsModel, LeagueInstanceModel, UserModel){
	var LastPickView = Backbone.View.extend({
		initialize: function(options) {
			this.pickSummaryCollection = options.pickSummaryCollection;
			this.draftStatus = options.draftStatus;			
			this.leagueInstance = options.leagueInstance;
			this.user = options.user;
			this.posColors = options.posColors;
			
			this.listenTo(this.user, 'change', this.pickOwnerRender);
			this.listenTo(this.draftStatus, 'change', this.render);
			this.listenTo(this.posColors, 'change', this.render);
			
			_.bindAll(this, 'openDelPickPopup');
			_.bindAll(this, 'undoNomination');
			_.bindAll(this, 'completeBid');			
			_.bindAll(this, 'render');
			_.bindAll(this, 'successCallback');
			_.bindAll(this, 'errorCallback');
			
			$(document).on('draftApp:playerUnpicked', this.render);
			
			if($(this.el).has('#lastPickContent').length){
				$("#draftBoardHdrLastPickUndoBtn").on('click', this.openDelPickPopup);
				$("#undoLastPickBtn").on('click', this.openDelPickPopup);
				$("#undoLastPickNomBtn").on('click', this.undoNomination);
				$("#completeLastPickBtn").on('click', this.completeBid);
			}						
		},
		
		render: function () {
			var lastPickSumId = this.pickSummaryCollection.getLastPosRoundId();
			var playerLoaded = false;
			var playerPos = null;
			var playerByeWeek = null;
			var playerTeamAbbr = null;
			var playerFirstName = null;
			var playerLastName = '';
			var bidAmount = null;
			
			if(this.leagueInstance.get('draftType') == 'AUCTION' && this.draftStatus.get('auctionBidding') && this.draftStatus.get('auctionBidPlayerId')){
				lastPickSumId = -1;
				if(this.playerList){
					var foundPlayer = this.playerList.findPlayerByDraftPlayerId(this.draftStatus.get('auctionBidPlayerId'));
					
					if(foundPlayer){
						playerPos = foundPlayer.position;
						playerByeWeek = foundPlayer.byeWeek;
						playerTeamAbbr = foundPlayer.teamAbbr;
						playerFirstName = foundPlayer.firstName;
						playerLastName = foundPlayer.lastName;
						bidAmount = this.draftStatus.get('auctionBidValue');
						playerLoaded = true;
					} else if(this.draftStatus.get('auctionManualPlayerLastName') !=  null){
						playerPos = this.draftStatus.get('auctionManualPlayerPos');
						playerByeWeek = this.draftStatus.get('auctionManualPlayerByeWeek');
						playerTeamAbbr = this.draftStatus.get('auctionManualPlayerTeamAbbr');
						playerFirstName = this.draftStatus.get('auctionManualPlayerFirstName');
						playerLastName = this.draftStatus.get('auctionManualPlayerLastName');
						bidAmount = this.draftStatus.get('auctionBidValue');
						playerLoaded = true;
					}
					
				}
			} else if(this.leagueInstance.get('draftType') == 'AUCTION' && lastPickSumId != -1){
				lastPickSumId = this.pickSummaryCollection.getAucPickByPosRoundId(lastPickSumId).get('id');
			}
			
			if(lastPickSumId != -1){
				var lastPickSum = this.pickSummaryCollection.get(lastPickSumId);
				
				playerPos = lastPickSum.get('playerPos');
				playerByeWeek = lastPickSum.get('byeWeek');
				playerTeamAbbr = lastPickSum.get('teamAbbr');
				playerFirstName = lastPickSum.get('fName');
				playerLastName = lastPickSum.get('lName');
				
				playerLoaded = true;
			}
			
			if($(this.el).has('#lastPickContent').length){
				//Standard version
				if(playerLoaded){
					$(this.el).find('.playerPos').html(playerPos ? playerPos : '&nbsp;');
					$(this.el).find('.playerBye').html((playerByeWeek && playerByeWeek > 0) ? playerByeWeek : '&nbsp;');
					$(this.el).find('.playerTeam').html(playerTeamAbbr ? playerTeamAbbr : '&nbsp;');
					$(this.el).find('.playerFName').html(playerFirstName ? playerFirstName : '&nbsp;');
					$(this.el).find('.playerLName').html(bidAmount > 0 ? '$' + bidAmount + ' ' + playerLastName : playerLastName);
					
					//Clear out all position/keeper classes
					$(this.el).find('.pick').removeClass('keeper');
					
					//Position background color
					if(playerPos){
						var color = this.posColors.retrievePosColor(playerPos);
						$(this.el).find('.pick').css({'background-color': color});
					} else {
						$(this.el).find('.pick').css({'background-color': '#FFFFFF'});
					}
					
					//Update Last Pick to delete
					if(lastPickSumId != -1){
						$(document).trigger('draftApp:delPickSum', [lastPickSumId]);
					} else {
						$(document).trigger('draftApp:delPickSum', [0]);
					}
					
				} else {
					$(this.el).find('.playerPos').html('&nbsp;');
					$(this.el).find('.playerBye').html('&nbsp;');
					$(this.el).find('.playerTeam').html('&nbsp;');
					$(this.el).find('.playerFName').html('&nbsp;');
					$(this.el).find('.playerLName').html('None');
					
					//Clear out all position/keeper classes
					$(this.el).find('.pick').removeClass('keeper');
					
					//Position background color
					$(this.el).find('.pick').css({'background-color': '#FFFFFF'});
					
					//Update Last Pick to delete
					$(document).trigger('draftApp:delPickSum', [0]);
				}
			} else {
				//Mobile version
				if(playerLoaded){
					var dispStr = '';
					
					if(!playerFirstName){
						dispStr += playerLastName + ' ';
					} else {
						dispStr = playerPos ? playerPos + ' ' : '';
						dispStr += playerLastName + ', ' + playerFirstName + ' ';
						dispStr += playerTeamAbbr ? '(' + playerTeamAbbr + ')' : '';
					}
					
					dispStr = bidAmount > 0 ? '$' + bidAmount + ' ' + dispStr : dispStr;
					
					//Update Last Pick to delete
					if(lastPickSumId != -1){
						$(document).trigger('draftApp:delPickSum', [lastPickSumId]);
					} else {
						$(document).trigger('draftApp:delPickSum', [0]);
					}
										
					$(this.el).find('#draftBoardHdrLastPickInfo b').html(dispStr);					
				} else {
					$(this.el).find('#draftBoardHdrLastPickInfo b').html('None');
				}
			}
			
			this.pickOwnerRender();
			
			return this;
		},
		
		pickOwnerRender: function () {
			var userName = this.user.get('userName');
			var isAssistant = this.leagueInstance.isAssistant(userName);
			var lastPosRoundId = this.pickSummaryCollection.getLastPosRoundId();
			
			if(this.leagueInstance.get('draftType') == 'AUCTION' && this.draftStatus.get('auctionBidding') && this.draftStatus.get('auctionBidPlayerId')){
				lastPosRoundId = -1;
			} else if(this.leagueInstance.get('draftType') == 'AUCTION' && lastPosRoundId != -1){
				lastPickSumId = this.pickSummaryCollection.getAucPickByPosRoundId(lastPosRoundId).get('id');
			}
			
			var lastPickSum = null;
			
			if(lastPosRoundId != -1){
				lastPickSum = this.pickSummaryCollection.get(lastPosRoundId);
			}
			
			if(lastPickSum){
				$(this.el).removeClass('bidding');
				var teamOwner = this.leagueInstance.getTeamOwner(lastPickSum.get('fantasyTeamId'));
				
				if(isAssistant || (
							userName.toUpperCase() == teamOwner.toUpperCase() 
							&& this.leagueInstance.get('draftType') != 'AUCTION'
							&& this.leagueInstance.get('undoEnabled')
						)){
					$(this.el).addClass('lastPickOwner');
				} else {
					$(this.el).removeClass('lastPickOwner');
				}
			} else if(this.leagueInstance.get('draftType') == 'AUCTION' && this.draftStatus.get('auctionBidding') && this.draftStatus.get('auctionBidPlayerId')){
				$(this.el).addClass('bidding');
				$(this.el).removeClass('lastPickOwner');
				
				if(isAssistant){
					$(this.el).addClass('commish');
				} else {
					$(this.el).removeClass('commish');
				}
			} else {
				$(this.el).removeClass('lastPickOwner');
				$(this.el).removeClass('bidding');
			}
		},
		
		loadPlayerList: function(playerList) {
			this.playerList = playerList;
			this.render();
		},
		
		completeBid: function() {
			if(!this.submitted && this.draftStatus.get('auctionBidding')){
				this.submitted = true;
				
				$.ajax({
					headers : {
						"Content-Type" : "application/json",
						"Accept" : "application/json"
					},
					url : 
						'/draftapp/leagues/' 
						+ this.leagueInstance.get('leagueId') 
						+ '/league-instances/' 
						+ this.leagueInstance.get('id') 
						+ '/picks/'
						+ this.draftStatus.get('auctionPickId')
						+ '/complete',
					type : 'PUT',
					dataType : 'json',
					//data : JSON.stringify(dataJson, null, 2),
					success: this.successCallback,
					error: this.errorCallback
				});
			}
		},
		
		undoNomination: function() {
			if(!this.submitted && this.draftStatus.get('auctionBidding')){
				this.submitted = true;
				
				$.ajax({
					headers : {
						"Content-Type" : "application/json",
						"Accept" : "application/json"
					},
					url : 
						'/draftapp/leagues/' 
						+ this.leagueInstance.get('leagueId') 
						+ '/league-instances/' 
						+ this.leagueInstance.get('id') 
						+ '/picks/'
						+ this.draftStatus.get('auctionPickId'),
					type : 'DELETE',
					dataType : 'json',
					//data : JSON.stringify(dataJson, null, 2),
					success: this.successCallback,
					error: this.errorCallback
				});
			}
		},
		
		successCallback: function(model, response) {
			this.submitted = false;
		},
		
		errorCallback: function(model, error) {
			this.submitted = false;
		},
		
		openDelPickPopup: function (event) {
			//$(document).trigger('draftApp:delPickSum', [this.pickSummary.get('id')]);
			
			var width = $(document).width();
			var height = $(document).height();
			
			var popupRight = width - event.pageX;
			var popupTop = event.pageY + 15;
			
			if(popupRight > (width - 225)){
				popupRight = width - 225;
			}
			if(popupTop > (height -300)){
				popupTop = height -300;
			}
			
			$('#delPickPopup .dropdown-menu').css('top', popupTop);
			$('#delPickPopup .dropdown-menu').css('right', popupRight);
		}
	});
	
	return LastPickView;  
});